$(document).ready(function(){

  if($(".product-form__cart-submit").is('[disabled=disabled]')){
    $('.klaviyo-bis-trigger').show();
  } else {
      $('.klaviyo-bis-trigger').hide();
  }
  
  $('.product__chip').on('click', function() {
    if($(".product-form__cart-submit").is('[disabled=disabled]')){
    $('.klaviyo-bis-trigger').show();
  } else {
      $('.klaviyo-bis-trigger').hide();
  }
  });

  $("#lang-list-footer .disclosure-list__option[lang='es-ES']").text("Español");
  setTimeout(function() {
    if($("html[lang='es-ES']").length){
    $(".footer__selectors .disclosure__toggle").text("Español");
  } else if($("html[lang='en']").length) {
      $(".footer__selectors .disclosure__toggle").text("English");
  }
    $('.drawer-menu__link[data-value="es-ES"]').find("span").text("Español");
  }, 1400);

  
  setTimeout(function() {
    let productItem1 = $('.collection__products .product-item:nth-child(16)');
    $('#collection-asset-1').insertAfter(productItem1);
  }, 1800);

  setTimeout(function() {
    let productItem2 = $('.collection__products .product-item:nth-child(33)');
    $('#collection-asset-2').insertAfter(productItem2);
  }, 1800);

  // Hide out of stock products when filtered
  let currentPage = location.href;
    
  setInterval(function() {
    if (currentPage != location.href) {
      if (window.location.href.indexOf("filter") > -1) {
      $('.collection__products').addClass("collection__products--filtered");
      }
      currentPage = location.href;
          
          // do your thing..
      }
  }, 500);

   if (window.location.href.indexOf("filter") > -1) {
      $('.collection__products').addClass("collection__products--filtered");
    }

     
  
});